/* Automatically generated by './scripts/build-routes.js' */
import Home from './home';

export default [{
  path: '/',
  name: 'home',
  component: Home,
},{
  name: 'Attraction',
  path: '/attraction',
  component: () => import('components/Attraction.vue'),
},{
  name: 'ball',
  path: '/ball',
  component: () => import('components/ball.vue'),
},{
  name: 'Birds',
  path: '/birds',
  component: () => import('components/Birds.vue'),
},{
  name: 'brick',
  path: '/brick',
  component: () => import('components/brick.vue'),
},{
  name: 'Circle',
  path: '/circle',
  component: () => import('components/Circle.vue'),
},{
  name: 'CircleParticles',
  path: '/circleparticles',
  component: () => import('components/CircleParticles.vue'),
},{
  name: 'ColorfulLines',
  path: '/colorfullines',
  component: () => import('components/ColorfulLines.vue'),
},{
  name: 'ColorfulLines2',
  path: '/colorfullines2',
  component: () => import('components/ColorfulLines2.vue'),
},{
  name: 'Cone',
  path: '/cone',
  component: () => import('components/Cone.vue'),
},{
  name: 'Connection',
  path: '/connection',
  component: () => import('components/Connection.vue'),
},{
  name: 'Cube',
  path: '/cube',
  component: () => import('components/Cube.vue'),
},{
  name: 'CubesTween',
  path: '/cubestween',
  component: () => import('components/CubesTween.vue'),
},{
  name: 'DashedLines',
  path: '/dashedlines',
  component: () => import('components/DashedLines.vue'),
},{
  name: 'demo',
  path: '/demo',
  component: () => import('components/demo.vue'),
},{
  name: 'Geometry',
  path: '/geometry',
  component: () => import('components/Geometry.vue'),
},{
  name: 'Gravity',
  path: '/gravity',
  component: () => import('components/Gravity.vue'),
},{
  name: 'Hierarchy',
  path: '/hierarchy',
  component: () => import('components/Hierarchy.vue'),
},{
  name: 'InteractiveCubes',
  path: '/interactivecubes',
  component: () => import('components/InteractiveCubes.vue'),
},{
  name: 'Lines',
  path: '/lines',
  component: () => import('components/Lines.vue'),
},{
  name: 'Loading',
  path: '/loading',
  component: () => import('components/Loading.vue'),
},{
  name: 'Materials',
  path: '/materials',
  component: () => import('components/Materials.vue'),
},{
  name: 'MouseBalls',
  path: '/mouseballs',
  component: () => import('components/MouseBalls.vue'),
},{
  name: 'Panorama',
  path: '/panorama',
  component: () => import('components/Panorama.vue'),
},{
  name: 'particle',
  path: '/particle',
  component: () => import('components/particle.vue'),
},{
  name: 'ParticleDemo',
  path: '/particledemo',
  component: () => import('components/ParticleDemo.vue'),
},{
  name: 'PictureFrame',
  path: '/pictureframe',
  component: () => import('components/PictureFrame.vue'),
},{
  name: 'Shape',
  path: '/shape',
  component: () => import('components/Shape.vue'),
},{
  name: 'SphereLines',
  path: '/spherelines',
  component: () => import('components/SphereLines.vue'),
},{
  name: 'ticTacToe',
  path: '/tictactoe',
  component: () => import('components/ticTacToe.vue'),
},{
  name: 'ticTacToe2',
  path: '/tictactoe2',
  component: () => import('components/ticTacToe2.vue'),
},{
  name: 'TreeFarm',
  path: '/treefarm',
  component: () => import('components/TreeFarm.vue'),
},{
  name: 'VoxelPainter',
  path: '/voxelpainter',
  component: () => import('components/VoxelPainter.vue'),
},{
  name: 'Waves',
  path: '/waves',
  component: () => import('components/Waves.vue'),
}];